import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import ThankYouPage from './pages/ThankYouPage';
import { LeadModalProvider } from './context/LeadModalContext';

const BlogIndex = lazy(() => import('./pages/BlogIndex'));
const BlogPost = lazy(() => import('./pages/BlogPost'));

function PageFallback() {
  return (
    <div className="page-loading" role="status" aria-live="polite">
      <div className="page-loading-inner">Loading…</div>
    </div>
  );
}

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="container" style={{ paddingTop: '6rem', paddingBottom: '2rem' }}>
          <h1 style={{ fontSize: '1.25rem' }}>Something went wrong</h1>
          <p style={{ color: '#64748b', lineHeight: 1.6 }}>
            The app hit an error while rendering. Open the browser developer console (F12 → Console) for details, or try a
            hard refresh. If you just pulled changes, run <code>npm install</code> and restart <code>npm start</code>.
          </p>
          <pre
            style={{
              marginTop: '1rem',
              padding: '1rem',
              background: '#f1f5f9',
              borderRadius: '0.5rem',
              fontSize: '0.8rem',
              overflow: 'auto',
            }}
          >
            {String(this.state.error)}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppErrorBoundary>
          <LeadModalProvider>
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<HomePage />} />
                <Route path="about" element={<AboutPage />} />
                <Route path="contact" element={<ContactPage />} />
                <Route path="thank-you" element={<ThankYouPage />} />
                <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="terms-of-service" element={<TermsOfServicePage />} />
                <Route
                  path="blog"
                  element={
                    <Suspense fallback={<PageFallback />}>
                      <BlogIndex />
                    </Suspense>
                  }
                />
                {/* Dynamic posts: /blog/:slug — content in src/data/blogPosts.js */}
                <Route
                  path="blog/:slug"
                  element={
                    <Suspense fallback={<PageFallback />}>
                      <BlogPost />
                    </Suspense>
                  }
                />
              </Route>
            </Routes>
          </LeadModalProvider>
        </AppErrorBoundary>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
